import React from 'react';
import { View } from 'react-native-web';
import { Tag } from 'component/button';
import { ToolTip, DocumentLevelTooltip } from '../tooltip';
import { component, demoFile, story, HOVER } from 'system/demo';

demoFile('open-modules/zdf/component/tooltip');

function ToolTipDemo() {
    return (
        <ToolTip label="Tooltip">
            <View testID="tool-target">
                <Tag text="Hover" />
            </View>
        </ToolTip>
    );
}

component('ToolTip', ToolTipDemo, {}, [
    story('Hover', [HOVER('tool-target')])
]);

function DocumentLevelTooltipDemo() {
    return (
        <DocumentLevelTooltip label="Tooltip">
            <View testID="doc-target">
                <Tag text="Hover me" />
            </View>
        </DocumentLevelTooltip>
    );
}

component('DocumentLevelTooltip', DocumentLevelTooltipDemo, {}, [
    story('Hover', [HOVER('doc-target')])
]);
